// 图片全屏查看组件类
class ImagePopup {
    constructor(config) {
        // 合并默认配置和用户配置
        this.config = {
            images: [],
            container: null,
            popup: null,
            openButton: null,
            ...config
        };
        
        // 初始化变量
        this.popup = document.querySelector(this.config.popup);
        this.swiper = null;
        this.currentIndex = 0;
        console.log(this.popup, 'popup');
        // 初始化组件
        this.init();
    }
    
    // 初始化组件
    init() {
        // 创建画廊缩略图
        if (this.config.container) {
            this.createThumbnails();
        }
        
        // 绑定打开按钮事件
        if (this.config.openButton) {
            const openButton = document.querySelector(this.config.openButton);
            if (openButton) {
                openButton.addEventListener('click', () => {
                    this.open(0);
                });
            }
        }
        
        // 绑定关闭按钮事件
        const closeBtn = this.popup.querySelector('.close-btn');
        closeBtn.addEventListener('click', () => {
            this.close();
        });
        
        // 点击背景关闭
        this.popup.addEventListener('click', (e) => {
            if (e.target === this.popup) {
                this.close();
            }
        });
        
        // 初始化Swiper
        this.initSwiper();
        
        // 绑定键盘事件
        this.bindKeyboardEvents();
    }
    
    // 创建缩略图
    createThumbnails() {
        const container = document.querySelector(this.config.container);
        if (!container) return;
        
        const containerImages = container.querySelectorAll('.swiper-slide-image');
        containerImages.forEach((item, index) => {
            console.log(item, 'item');
            item.addEventListener('click', () => {
                
                this.open(index);
            });
        });
    }
    
    // 初始化Swiper
    initSwiper() {
        const swiperContainer = this.popup.querySelector('.swiper-container');
        const swiperWrapper = this.popup.querySelector('.swiper-wrapper');
        
        // 清空现有幻灯片
        swiperWrapper.innerHTML = '';
        
        // 创建幻灯片
        this.config.images.forEach(image => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            slide.innerHTML = `<img src="${image}">`;
            swiperWrapper.appendChild(slide);
        });
        
        // 初始化Swiper
        this.swiper = new Swiper(swiperContainer, {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            loop: false,
            keyboard: {
                enabled: true,
            },
            on: {
                slideChange: () => {
                    this.updateCounter();
                }
            }
        });
        
        // 更新计数器
        this.updateCounter();
    }
    
    // 更新计数器
    updateCounter() {
        if (!this.swiper) return;
        
        const current = this.popup.querySelector('.current');
        const total = this.popup.querySelector('.total');
        
        if (current && total) {
            current.textContent = this.swiper.activeIndex + 1;
            total.textContent = this.config.images.length;
        }
    }
    
    // 绑定键盘事件
    bindKeyboardEvents() {
        document.addEventListener('keydown', (e) => {
            if (!this.popup.classList.contains('active')) return;
            
            if (e.key === 'Escape') {
                this.close();
            } else if (e.key === 'ArrowRight') {
                if (this.swiper) {
                    this.swiper.slideNext();
                }
            } else if (e.key === 'ArrowLeft') {
                if (this.swiper) {
                    this.swiper.slidePrev();
                }
            }
        });
    }
    
    // 打开图片弹窗
    open(index = 0) {
        console.log(index, 'index');
        if (index >= 0 && index < this.config.images.length) {
            this.currentIndex = index;
            console.log(this.currentIndex, 'this.currentIndex');
            
            
            if (this.swiper) {
                this.swiper.slideTo(index, 0);
            }
            
            this.popup.classList.add('active');
            document.body.style.overflow = 'hidden';
            
            // 更新计数器
            this.updateCounter();
        }
    }
    
    // 关闭图片弹窗
    close() {
        this.popup.classList.remove('active');
        document.body.style.overflow = 'auto';
    }
    
    // 更新图片列表
    // updateImages(images) {
    //     this.config.images = images;
        
    //     // 重新创建缩略图
    //     if (this.config.container) {
    //         this.createThumbnails();
    //     }
        
    //     // 重新初始化Swiper
    //     this.initSwiper();
    // }
}